/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/*global dw*/
import {ACTIVE_DATA_ENABLED} from '@salesforce/retail-react-app/app/constants'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'

const useActiveData = () => {
    // Returns true when the feature flag is enabled and the tracking scripts have been executed
    // This MUST be called before using the `dw` variable, otherwise a ReferenceError will be thrown
    const canTrack = () => ACTIVE_DATA_ENABLED && typeof dw !== 'undefined'
    return {
        async trackPage(siteId, localeId, currency) {
            if (!canTrack()) return
            try {
                var activeDataUrl =
                    '/on/demandware.store/Sites-' +
                    siteId +
                    '-Site/' +
                    localeId +
                    '/__Analytics-Start'
                var dwAnalytics = dw.__dwAnalytics.getTracker(activeDataUrl)
                if (typeof dw.ac == 'undefined') {
                    dwAnalytics.trackPageView()
                } else {
                    try {
                        if (typeof dw.ac._setSiteCurrency === 'function') {
                            dw.ac._setSiteCurrency(currency)
                        }
                    } catch (err) {
                        logger.error('ActiveData trackPage error', {
                            namespace: 'useActiveData.trackPage',
                            additionalProperties: {error: err}
                        })
                    }
                    dw.ac.setDWAnalytics(dwAnalytics)
                }
            } catch (err) {
                logger.error('ActiveData trackPage error', {
                    namespace: 'useActiveData.trackPage',
                    additionalProperties: {error: err}
                })
            }
        }
    }
}

export default useActiveData
